function loadAsistenDosen(view) {
    return () => import( /* webpackChunkName: "asisten-[request]" */ `../views/AsistenDosen/${view}.vue`)
}
const asistenDosenRoute = [
    {
        path: '/asisten-dosen/oprec',
        name: 'OprecAssistant',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadAsistenDosen('OprecAssistant')
    },
    {
        path: '/asisten-dosen/oprec-detail/:oprecId',
        name: 'OprecAssistantDetail',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadAsistenDosen('OprecAssistantDetail')
    },
    {
        path: '/asisten-dosen/oprec-detail',
        name: 'OprecAssistantDetailMahasiswa',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadAsistenDosen('OprecAssistantDetail')
    },
    {
        path: '/asisten-dosen/registration',
        name: 'AssistantRegistrationMahasiswa',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadAsistenDosen('AssistantRegistrationMahasiswa')
    },
    {
      path: '/asisten-dosen/oprec-detail/:oprecId/exam/:oprecDetailId',
      name: 'AssistantExam',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantExam')
    },
    {
      path: '/asisten-dosen/exam/:oprecDetailId',
      name: 'AssistantExamMahasiswa',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantExam')
    },
    {
      path: '/assistant-rubric',
      name: 'RubricAssistantField',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('RubricAssistantField')
    },
    {
      path: '/assistant-blacklist',
      name: 'AssistantBlacklist',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantBlacklist')
    },
    {
      path: '/assistant/report',
      name: 'ExportReportProdi',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('ExportReportProdi')
    },
    {
      path: '/assistant/report/faculty',
      name: 'ExportReportFaculty',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('ExportReportFaculty')
    },
    {
      path: '/assistant/report/dosen',
      name: 'ExportReportForDosen',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('ExportReportForDosen')
    },
    {
        path: '/asisten-dosen/oprec-detail/:oprecId/list-pendaftar/:oprecDetailId',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadAsistenDosen('MainViewVerification'),
        children: [
          {
              path: '',
              name: 'ListMahasiswaRegistration',
              component: loadAsistenDosen('ListMahasiswaRegistration')
          },
          {
            path: 'verifikasi-dosen',
            name: 'AssistantVerificationDosen',
            component: loadAsistenDosen('AssistantVerificationDosen')
          },
          {
            path: 'verifikasi-kalab',
            name: 'AssistantVerificationKalab',
            component: loadAsistenDosen('AssistantVerificationKalab')
          },
        ]
    },
    {
      path: '/asisten-dosen/absensi',
      name: 'AssistantAttendanceListOprec',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantAttendanceListOprec')
    },
    {
      path: '/asisten-dosen/absensi/:study_course_id/:semester_id',
      name: 'AssistantAttendanceListMahasiswa',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantAttendanceListMahasiswa')
    },
    {
      path: '/asisten-dosen/absensi/:study_course_id/:semester_id/activity/:registration_id',
      name: 'AssistantAttendanceListAbsensi',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantAttendanceListAbsensi')
    },
    {
      path: '/asisten-dosen/absensi/:registration_id',
      name: 'AssistantAttendanceMahasiswaView',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantAttendanceMahasiswaView')
    },
    {
      path: '/asisten-dosen/evalusi',
      name: 'AssistantEvaluationListOprec',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantEvaluationListOprec')
    },
    {
      path: '/asisten-dosen/evalusi/:study_course_id/:semester_id',
      name: 'AssistantEvaluationResult',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantEvaluationResult')
    },
    {
      path: '/asisten-dosen/evaluasi/:registration_id',
      name: 'AssistantEvaluationMahasiswaView',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadAsistenDosen('AssistantEvaluationMahasiswaView')
    },
]

export default asistenDosenRoute